var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"OrderDetails"},[_c('Header'),_c('div',{staticStyle:{"width":"1000px","overflow":"hidden","overflow-y":"auto","scrollbar-width":"none"},style:({
        'margin-left': _vm.innerWidth > 1000 ? (_vm.innerWidth - 1000) / 2 + 'px' : '0px',
        'height': (_vm.innerHeight - 70 - 68) + 'px'
    })},[_c('div',{staticClass:"title"},[_vm._v("我的订单")])]),_c('Suspension'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }